module.exports = __webpack_public_path__ + "img/success.8e607dce.svg";